import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetOrganizationRecommendations = () => {
  const query = useApiQuery(
    ['schools', 'organizationRecommendations'],
    'schools',
    '/current-organization/recommendations',
    { enabled: true }, // Siempre está habilitado al cargar el componente
    { authenticated: true, version: 4 }
  )

  return {
    isLoadingRecommendations: query.isLoading,
    isFetchingRecommendations: query.isFetching,
    dataRecommendations: query.data ?? null,
    errorResultRecommendations: query.isError || query.isRefetchError ? query.error : null,
    refetchRecommendations: query.refetch
  }
}
